module.exports = __webpack_public_path__ + "static/media/Aggron_gaussian2.ff0942b4.png";